import CloseButton from 'components/Button/CloseButton';
import CreateNewClassForm from 'containers/CreateNewClassForm';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getUser } from 'store/actions/user';

import styles from './AddStudents.module.scss';

const AddStudents = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { classId } = useParams();
  const { currClass = {} } = useSelector(({ user }) => {
    const currClass = user.classrooms.find(({ id }) => +id === +classId);

    return { currClass };
  });

  const onClose = () => {
    dispatch(getUser());
    navigate(-1);
  };

  return (
    <div className={styles.addClassContainer}>
      <CloseButton variant="primary" onClick={onClose} className={styles.closeButton} />
      <CreateNewClassForm
        modal={false}
        welcomeStep={false}
        classroomStep={false}
        handleCancel={onClose}
        masterPassword={currClass?.master_password}
      />
    </div>
  );
};

export default AddStudents;
